// for customer Dashbaord recent payments widget
export const GET_RECENT_PAYMENTS = "get_recent_payments";
export const GET_RECENT_PAYMENTS_SUCCESS = "get_recent_payments_success";
export const GET_RECENT_PAYMENTS_FAILURE = "get_recent_payments_failure";
